var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('form',{ref:"itemsContainer",class:_vm.formClasses,attrs:{"id":_vm.formId},on:{"wheel":_vm.onWheel}},[_c('fieldset',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }